if (!customElements.get('product-sticky-atc')) {
  customElements.define(
    'product-sticky-atc',
    class ProductStickyAtc extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.formId);
        this.button = this.querySelector('.product-sticky-atc__button');
        this.buttonText = this.button?.querySelector('span');
        this.price = this.querySelector('.product-sticky-atc__price');
        this.bindSourceElements();

        this.sourceObserver = new MutationObserver(() => this.sync());
        this.priceObserver = new MutationObserver(() => this.sync());

        if (this.sourceButton) {
          this.sourceObserver.observe(this.sourceButton, {
            attributes: true,
            attributeFilter: ['aria-disabled', 'disabled', 'class'],
            childList: true,
            subtree: true,
          });
        }
        if (this.priceSource) {
          this.priceObserver.observe(this.priceSource, {
            childList: true,
            subtree: true,
          });
        }

        this.sync();
      }

      disconnectedCallback() {
        this.sourceObserver?.disconnect();
        this.priceObserver?.disconnect();
      }

      bindSourceElements() {
        this.form = document.getElementById(this.dataset.formId);
        this.sourceButton = this.form?.querySelector('[name="add"]');
        this.priceSource = document.getElementById(`price-${this.dataset.sectionId}`);
      }

      sync() {
        if (!this.button || !this.sourceButton) return;

        const isDisabled =
          this.sourceButton.disabled || this.sourceButton.getAttribute('aria-disabled') === 'true';
        const isLoading = this.sourceButton.classList.contains('loading');
        const sourceText = this.sourceButton.querySelector('span')?.textContent?.trim();
        const currentPrice =
          this.priceSource?.querySelector('.price__sale .price-item--sale')?.textContent?.trim() ||
          this.priceSource?.querySelector('.price__regular .price-item--regular')?.textContent?.trim();

        this.button.disabled = isDisabled && !isLoading;
        this.button.toggleAttribute('aria-disabled', isDisabled);
        this.button.classList.toggle('loading', isLoading);
        this.button.querySelector('.loading__spinner')?.classList.toggle('hidden', !isLoading);

        if (sourceText && this.buttonText) this.buttonText.textContent = sourceText;
        if (currentPrice && this.price) this.price.textContent = currentPrice;
      }
    },
  );
}
